// return a fallback state depending on how data is filtered in searchFilterOrders

export function getFallbackStateOrders({ isLoading, allData, filteredData }) {
  // While data is being fetched
  if (isLoading) return { state: "loading" };

  // No orders at all
  if (!allData || allData.length === 0) {
    return { state: "noData" };
  }

  // No matching orders after search/filter
  if (filteredData.length === 0) {
    return { state: "noMatch" };
  }

  // Normal successful state
  return { state: "ok" };
}
